<template>
	<div>
		<Header />

		<div>
			<Carousel loop :height="350" arrow="never" dots="none">
				<CarouselItem>
					<div class="banner">
						<div>
							<p class="pageType">商情类服务</p>
						</div>
					</div>
				</CarouselItem>
			</Carousel>
			<div>
				<div class="serviceIntroduction">
					<ul class="serviceTypeList">
						<p>商情类服务</p>
						<li v-for="(item,i) in data" :class="{'active':i+1==type}" @click="skipService(i)">
							{{item.title}}
						</li>
					</ul>
					<div class="introductionInfo">
						<p>{{data[type-1].title}}</p>
						<div class="serviceContent">
							<component :is="data[type-1].component"></component>
						</div>
					</div>

					<div style="clear: both;"></div>
				</div>

			</div>

		</div>

		<ContactUs />
		<Footer />
	</div>
</template>

<script>
	import Header from '@/common/header'
	import Footer from '@/common/footer.vue'
	import ContactUs from '@/common/contactUs.vue'
	import BusinessPlanWriting from '@/views/services/businessServices/components/businessPlanWriting.vue'
	import FeasibilityReportWriting from '@/views/services/businessServices/components/feasibilityReportWriting.vue'
	import DueDiligence from '@/views/services/businessServices/components/dueDiligence.vue'
	import ProjectApplication from '@/views/services/businessServices/components/projectApplication.vue'

	import {
		merge
	} from 'lodash'

	export default {
		components: {
			Header,
			Footer,
			ContactUs,
			BusinessPlanWriting,
			FeasibilityReportWriting,
			DueDiligence,
			ProjectApplication

		},
		data() {
			return {
				type: this.$route.query.type,
				data: [{
					title: '商业计划书撰写',
					component: 'BusinessPlanWriting'
				}, {
					title: '可行性报告撰写',
					component: 'FeasibilityReportWriting'
				}, {
					title: '尽职调查',
					component: 'DueDiligence'
				}, {
					title: '项目申报',
					component: 'ProjectApplication'
				}]

			}
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);

		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		methods: {
			handleScroll() {
				if (window.pageYOffset >= 410) {
					$('.serviceTypeList').addClass('service-fixed')

				} else {
					$('.serviceTypeList').removeClass('service-fixed')
				}

			},
			skipService(i) {
				this.type = i + 1

				this.$router.push({
					query: merge({}, {
						'type': i + 1
					})
				})
			}


		}


	}
</script>

<style scoped lang="less">
	.banner {
		background: url(../../../assets/img/service/businessBanner.jpg) center center no-repeat
	}
</style>